<template>
  <div class="Stub-Content-Block">
    <div class="Stub-Content-Block__hdr">
      <div class="Stub-Content-Block__hdr__wrap">
        <img :src="SafeImg" alt="Safe" class="Stub-Content-Block__hdr__img"/>
        <TypographyTitle class="Stub-Content-Block__hdr__ttl" :level="'h2'">Эксклюзивно для Кэпиталистов</TypographyTitle>
      </div>
      <p class="Stub-Content-Block__hdr__txt">Купите любую NFT из коллекции PoN и получите <br>
        доступ ко всем разделам Drops Capital</p>
    </div>

    <div v-if="isLessThanMD" class="Stub-Content-Block__btn-group--adaptive">
      <ButtonMain class="Stub-Content-Block__btn" v-if="!get_isAuthenticated" @click="toOpenForm" :width="'100%'" :height="'45px'">Войти в профиль</ButtonMain>
      <div class="Stub-Content-Block__btn-group--adaptive__bot">
        <ButtonMain class="Stub-Content-Block__btn" :type="'blue-border'" :width="'127px'" :height="'45px'" :link="'https://opensea.io/collection/proof-of-narnian-nft-og'" target="_blank">OpenSea
          <ShareIcon/>
        </ButtonMain>
        <ButtonMain class="Stub-Content-Block__btn" :type="'blue-border'" :width="'127px'" :height="'45px'" :link="'https://blur.io/collection/proof-of-narnian-nft-og'" target="_blank">Blur
          <ShareIcon/>
        </ButtonMain>
      </div>
    </div>

    <BlockDropsDescription class="Stub-Content-Block__block" :style="{display: props.showDescription ? '' : 'none' }" :descriptionAdaptive="props.descriptionAdaptive"/>

    <div v-if="!isLessThanMD" class="Stub-Content-Block__btn-group">
      <ButtonMain class="Stub-Content-Block__btn" v-if="!get_isAuthenticated" @click="toOpenForm" :width="'200px'" :height="'45px'">Войти в профиль</ButtonMain>
      <ButtonMain class="Stub-Content-Block__btn" :type="'blue-border'" :width="'127px'" :height="'45px'" :link="'https://opensea.io/collection/proof-of-narnian-nft-og'" target="_blank">OpenSea
        <ShareIcon/>
      </ButtonMain>
      <ButtonMain class="Stub-Content-Block__btn" :type="'blue-border'" :width="'127px'" :height="'45px'" :link="'https://blur.io/collection/proof-of-narnian-nft-og'" target="_blank">Blur
        <ShareIcon/>
      </ButtonMain>
    </div>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useStore} from 'vuex';
import {Props} from './scripts/props.js';
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
import {useScreenSize} from "@shared/composables/screenWidth/useScreenSize";
//-------------------------------------------
import SafeImg from "@ui/Stubs/StubContent/images/png/safe.webp";
import LockIcon from "@svg/LockIcon.vue";
import AvatarImage from "@ui/Images/AvatarImage/AvatarImage.vue";
import TypographyTitle from "@ui/Typography/TypographyTitle/TypographyTitle.vue";
import ButtonMain from "@ui/Buttons/ButtonMain/ButtonMain.vue";
import BlockDropsDescription from "@shared/UI/Blocks/BlockDropsDescription/BlockDropsDescription.vue";
import ShareIcon from "@ui/Stubs/StubContent/images/svg/ShareIcon.vue";
//-------------------------------------------
const store = useStore();
const props = defineProps(Props());
//-------------------------------------------
const {isLessThanMD} = useScreenSize();
//-------------------------------------------
const PON_1 = require('@shared/images/icons/pon1.png');
const PON_2 = require('@shared/images/icons/pon2.png');
const PON_3 = require('@shared/images/icons/pon3.png');
const PON_4 = require('@shared/images/icons/pon4.png');
//-------------------------------------------
//Пользователь авторизирован?
const get_isAuthenticated = computed(() => store.state.UserSystem.user.isAuthenticated);
//-------------------------------------------
//Открыть форму
const toOpenForm = () => {
  store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.START_LOGIN);
  store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.auth);
}
</script>

<style lang="scss">
@import './styles/_style';
</style>
